/* eslint-disable object-shorthand */

export const PACKAGE_BUILD_DATE = '2026-11-05T06:09:02.434Z';
export const PACKAGE_NAME = '@invision/authentication';
export const PACKAGE_VERSION = '5.0.0-2703356';

export default {
  PACKAGE_BUILD_DATE: PACKAGE_BUILD_DATE,
  PACKAGE_NAME: PACKAGE_NAME,
  PACKAGE_VERSION: PACKAGE_VERSION
};
